import { VideoSizes } from '@anm/hosting-player';
import { useEffect, useState, RefObject } from 'react';

export const DEFAULT_PROPORTION = 0.36;

type UseVideoSizesProps = {
  sizes?: VideoSizes;
  container?: RefObject<HTMLDivElement>;
  fullWidth?: boolean;
  proportion?: number;
};

const useVideoSizes = ({
  container,
  sizes,
  fullWidth = false,
  proportion = DEFAULT_PROPORTION
}: UseVideoSizesProps) => {
  const [playerSizes, setPlayerSizes] = useState<VideoSizes>();

  useEffect(() => {
    const wrapper = container?.current;
    if (!wrapper || !sizes) return;

    if (fullWidth) {
      const videoWidth = wrapper.offsetWidth;
      const videoRatio = sizes.width / sizes.height;
      const videoHeight = Math.round(videoWidth / videoRatio);

      setPlayerSizes({
        width: videoWidth,
        height: videoHeight
      });
    } else {
      const containerArea = wrapper.offsetWidth * wrapper.offsetHeight;
      const videoRatio = sizes.width / sizes.height;

      const playerArea = Math.round(containerArea * proportion);
      const videoHeight = Math.round(Math.sqrt(playerArea / videoRatio));
      const videoWidth = Math.round(videoHeight * videoRatio);

      setPlayerSizes({
        width: videoWidth,
        height: videoHeight
      });
    }
  }, [container?.current]);

  return playerSizes;
};

export default useVideoSizes;
